import { useBehavior } from '@libs/core';
import { TTimerButtonData, TWidgetProps } from '@libs/types';
import React, { Activity, useMemo } from 'react';
import { TButtonOption } from '../../types/options';
import { TextCommon } from '../UI/Text/TextCommon';
import { ButtonRowWidget } from './ButtonRowWidget';
import { useInterval } from './hooks';
import { getSecondsToDate } from './utils/dateUtils';

export const TimerButton = ({ widget }: TWidgetProps<TTimerButtonData, TButtonOption>) => {
    const { isHidden } = useBehavior(widget);
    const data = widget.data ?? {};
    const options = widget.options ?? {};

    const totalSeconds = useMemo(() => getSecondsToDate(data.endDate), [data.endDate]);

    const { time, timerEnd } = useInterval(1000, totalSeconds);

    const getTextAlign = () => {
        if (options.alignment === 'center') {
            return 'center';
        }
        return 'start';
    };

    const content = timerEnd ? (
        <ButtonRowWidget widget={widget} />
    ) : (
        <TextCommon
            isWidget={false}
            uid={`timerText_${widget.uid}`}
            options={{ textColor: 'grey_72_lc', textAlign: getTextAlign(), ...options }}
            content={`${data.messages?.timerTitle || ''} ${time}`}
        />
    );

    return <Activity mode={isHidden ? 'hidden' : 'visible'}>{content}</Activity>;
};
